module.exports = __webpack_public_path__ + "img/visipoint-logo.6a73f51d.svg";